import Api from "./webrtcGuardApi"
import Router from "@/router";

export default {
    getConference(token, displayName, username) {
        displayName = encodeURIComponent(displayName)
        username = encodeURIComponent(username)
        return Api()
            .get(`join/check?token=${token}&displayName=${displayName}&username=${username}`)
            .then(resp => {
                if (resp.status === 200) {
                    if (resp.config.baseURL + resp.config.url !== resp.request.responseURL) {
                        location.replace(resp.request.responseURL);
                    }
                    return resp.data;
                }
                return null;
            });
    },
    getLatestSystemMessage() {
        return Api()
            .get("system-message")
            .then(resp => {
                if (resp.status === 200) {
                    if (resp.config.baseURL + resp.config.url !== resp.request.responseURL) {
                        location.replace(resp.request.responseURL)
                    }
                    return resp.data;
                }
                return null;
            });
    },
    getTestRoom() {
        return Api()
            .get(`test`)
            .then(resp => {
                if (resp.status === 200) {
                    {
                        Router.push({name: "WebrtcGuard", query: {token: resp.data.token, uuid: resp.data.uuid}})
                    }
                    return resp.data;
                }
                return null;
            });
    },

    reviewTestRoom(uuid, rate) {
        return Api()
            .post(`test/review/` + uuid + '?rate=' + rate)
            .then(resp => {
                    return resp.data;
                }
            );
    },

    setCaller(uuid, caller) {
        return Api()
            .post('test/setCaller/' + uuid + "?caller=" + caller)
            .then(resp => {
                return resp.data;
            }
        );
    },

    getIsThereOngoingMaintenance(){
        return Api()
            .get('maintenance/ongoing')
            .then(resp=>{
                if(resp.status === 200){
                    return resp.data;
                }
                return null;
            });
    },

};